import { OpenAPI as API } from '../services';
import { OpenAPI as ManagementAPI } from '../services/agents-management';

const removeTrailingSlashes = (url?: string): string => {
  if (!url?.length) return '';

  return url.replace(/\/+$/, '');
};

export * from './tasks';
export * from './context';
export * from './contacts';
export * from './campaigns';
export * from './prompts';
export * from './llm';
export * from './importer';
export * from './management';
export * from './messages';
export * from './misc';

const BASE_URL = process.env.REACT_APP_API_URL;
const MANAGEMENT_URL = process.env.REACT_APP_MANAGEMENT_API_URL;

if (process.env.NODE_ENV === 'development') {
  API.BASE = '/api';
  ManagementAPI.BASE = '/api/management';
} else {
  ManagementAPI.BASE = removeTrailingSlashes(MANAGEMENT_URL) + '/management';
  API.BASE = removeTrailingSlashes(BASE_URL);
}

export { API, ManagementAPI };
